/**
 * 住所変更のイベント設定
 */

// グローバル変数
var _address_search_settings_ = false;
var _address_search_data_     = false;

window.address_search_event_set = function ()
{
    var _zMapMain = $('#map');

    // 地図要素が無い時は何もしない
    if (_zMapMain.length <= 0) {
        return;
    }

    _address_search_settings_ = {
        messages: {
            /** ランドマークアイコン吹き出し表示用 */
            l_infobox: movement_base.l_infobox,
            /** 地点アイコン吹き出し表示用 */
            d_infobox: movement_base.d_infobox,
            /** 検索結果リスト表示用（住所） */
            info_list1: movement_config.address_search.info_list1.options,
            /** 検索結果リスト表示用（郵便番号） */
            info_list2: movement_config.address_search.info_list2.options,
            /** 検索結果リスト表示用（施設名） */
            info_list3: movement_config.address_search.info_list3.options,
            /** 情報表示エリア表示・非表示ボタン */
            right_area_show_button: address_search.right_area_show_button,
            right_area_hide_button: address_search.right_area_hide_button,
        }
    };

    initialize();


    /**
     * 画面の初期化処理を行います。
     */
    function initialize()
    {
        // 選択行init
        var _rowId = '';

        // --------------------------------
        // イベントセット
        // --------------------------------
        /**
         * 画面リサイズ時イベントの描画処理を行います。
         */
        $( window ).on('resize', function(){
            resizeDisplay();
        });

        /**
         * サイドバー切替ボタン押下時のイベント処理を行います
         */
        $(".sidebar-control").on('click', function(){
            setTimeout(function(){
                if (_zMapMain.mapLandmark){
                    _zMapMain.mapLandmark.resizeMap();
                }
            }, 400);
        });

        /**
         * リスト選択ボタン押下時イベントの処理を行います。
         */
        $('#search_type_buttons input[type=radio]').parent().on("click", function () {

            /** 現在の表示を初期化 */
            $('#search_input1, #search_input2, #search_input3').val(['']);

            /** 予め各検索条件エリア・リスト表示エリアを非表示化 */
            $('#search_type_area1, #search_type_area2, #search_type_area3').css('display', 'none');

            /** 検索タイプに従い、対応する検索条件エリア・リスト表示エリアを表示 */
            let selected_value = $(this).children('input[type=radio]').val();
            $('#search_type_area' + selected_value).css('display', 'inline');

            /** 地図リセット */
            resetMap(true);

            /** 検索結果リストを初期化 */
            initializeInfoList();
        });

        /**
         * 検索ボタン押下時イベントの処理を行います。
         */
        $(document).on('click', '#search_button1, #search_button2, #search_button3', function(){
            let search_type = $("input[name='search_types[]']:checked").val();
            let search_input= search_type.toString() === '1' ? $('#search_input1').val().replace(/　/g," ") :
                              search_type.toString() === '2' ? $('#search_input2').val().replace(/　/g," ") :
                              search_type.toString() === '3' ? $('#search_input3').val().replace(/　/g," ") :
                              null;
            getAddressSearchData(search_type, search_input);
        });

        /**
         * クリアボタン押下時イベントの処理を行います。
         */
        $('#clear_button1, #clear_button2, #clear_button3').on( "click", function() {
            /** 現在の表示を初期化 */
            $('#search_input1, #search_input2, #search_input3').val(['']);

            /** 予め各検索条件エリア・リスト表示エリアを非表示化 */
            // $('#search_type_area1, #search_type_area2, #search_type_area3').css('display', 'none');

            /** 地図リセット */
            resetMap(true);

            /** 検索結果リストを初期化 */
            initializeInfoList();
        });

        /**
         * リストヘッダクリック(ソート)
         */
        $(document).on('click', 'th.sorting, th.sorting_asc, th.sorting_desc', function(e) {
            let key = $(this).data('sort_key');
            let type = $(this).parents('table').data('type');
            onClickThInfoList(type, "#th_" + key);
        });

        /**
         * リスト行クリック
         * 選択行style＆地図上POPUP制御
         */
        $(document).on('click', '#info_list1_table tbody tr, #info_list2_table tbody tr, #info_list3_table tbody tr', function()
        {
            /* 行のクリックイベント */
            let rowId = $(this).data('row_id');
            let type = $(this).data('type');

            if (!$(this).hasClass('info_list-tr-selected')){
                /** 選択されていない場合 */

                /** 選択行の背景色を選択色に変更 */
                $(this).parent().children('tr').removeClass('info_list-tr-selected');    // 全行選択色リセット
                $(this).addClass('info_list-tr-selected');                               // 当該行に選択色セット

                /** 選択行に対応するアイコンの吹き出しを表示 */
                _zMapMain.mapLandmark.closeInfoboxLandmarkAll();
                _zMapMain.mapLandmark.openInfoboxLandmark(type, rowId);

            } else {
                /** 既に選択されている場合 */

                /** 当該行選択色リセット */
                $(this).removeClass('info_list-tr-selected');                            // 当該行の選択色リセット

                /** 当該行に対応するアイコンの吹き出しを閉じる */
                _zMapMain.mapLandmark.closeInfoboxLandmark(type, rowId);
            }

            return false;
        });

        /**
         * リスト行ダブルクリック
         * 選択行style＆地図上POPUP制御
         */
        $(document).on('dblclick', '#info_list1_table tbody tr, #info_list2_table tbody tr, #info_list3_table tbody tr', function()
        {
            let search_type = $('input[name="search_types[]"]:checked').val();
            let search_input = $(this).data('search_input');
            getAddressSearchData(search_type, search_input);

            return false;
        });

        /*---- 積卸地(地点)登録画面表示 ----*/
        $(document).on('click', '[data-setting-modal]', function (e)
        {
            // バブリング停止
            e.preventDefault();
            e.stopPropagation();

            let tr = $(this).parents('tr');
            // 選択行ID保持
            _rowId = tr.data('row_id');
            // パラメタ編集
            let params = {
                'id': tr.attr('data-loading_point_id'),
                'zipcode': tr.attr('data-zipcode'),
                'prefecture': tr.attr('data-prefecture'),
                'municipality': tr.attr('data-municipality'),
                'address': tr.attr('data-address_parts'),
                'latitude': tr.attr('data-latitude'),
                'longitude': tr.attr('data-longitude'),
                'name': tr.attr('data-facility_name') || '',
            };

            // 再検索なしで同じ行を選択した場合は更新処理とする
            if ((tr.attr('data-loading_point_id') || '') === '') {
                params.out_mode = 'movement';
            } else {
                params.id = tr.attr('data-loading_point_id');
            }
            // 施設名検索のときは、住所パーツがないため、指定レコードの住所検索で住所パーツを取得する
            if (params.prefecture === '') {
                let elm = this;
                // OAuthパラメタ取得
                let apiName = 'address/word';
                let data = {
                    api: apiName,
                    word: tr.attr('data-address'),
                    limit: 1,
                };
                _ajax.post(_zMapMain.data('map_api_url'), data, function (result) {
                    // WebAPI
                    ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                        if (status.code === 200 && res.info.hit > 0) {
                            let rec = res.item[0];
                            params.prefecture = rec.parts[0];
                            params.municipality = rec.parts[1];
                            params.address = rec.text.replace((rec.parts[0] + rec.parts[1]), ''); // 県市町村以下の情報

                            openSettingModal(elm, params);
                        } else {
                            // データ無ければ、住所パーツ無しでCALLする
                            params.address = tr.attr('data-address');
                            openSettingModal(elm, params);
                        }
                    });
                }, function(xhr, status, errorThrown){
                    _error.omitted(xhr, status, errorThrown);
                });
            } else {
                openSettingModal(this, params);
            }

            function openSettingModal(elm, params)
            {
                _modal.create_with_data(elm, 'setting-modal', params, true, function() {
                    loading_point_setting_event_set();
                });
            }
        });

        /*---- 地点登録の保存時 ----*/
        $(document).on('click', '[data-save-modal]', function () {
            _modal.submit(this, 'save-modal', function(results) {
                let type = $("input[name='search_types[]']:checked").val();

                // 選択行を登録データに置き換える
                if (results && results.loading_point) {
                    // tr取得
                    tr = $('#info_list' + type + '_table tr[data-row_id="' + _rowId + '"]');
                    if (tr.length === 0) return;
                    // 内部パラメタ項目data属性更新
                    let item = results.loading_point;
                    let address_parts = item.address;
                    let address = (item.prefecture || '') + (item.municipality || '') + (item.address || '');
                    tr.attr('data-prefecture', (item.prefecture || ''));
                    tr.attr('data-municipality', (item.municipality || ''));
                    tr.attr('data-address_parts', address_parts);
                    tr.attr('data-address', address);
                    tr.attr('data-zipcode', (item.zipcode || ''));
                    tr.attr('data-code', (item.code || ''));
                    tr.attr('data-latitude', (item.latitude || ''));
                    tr.attr('data-longitude', (item.longitude || ''));
                    tr.attr('data-facility_name', (item.name || ''));
                    tr.attr('data-loading_point_id', (item.id || ''));
                    // 表示内容更新
                    tr.find('td.display-facility_name').text((item.name || ''));
                    tr.find('td.display-address p').eq(0).text((item.zipcode || ''));
                    tr.find('td.display-address p').eq(1).text(address);

                    /** マーカー表示を更新 */
                    let marker_type = type;
                    let marker_id = _rowId;
                    let data = {
                        facility_name:      (item.name || ''),
                        zipcode:            (item.zipcode || ''),
                        address:            address,
                        latitude:           (item.latitude || ''),
                        longitude:          (item.longitude || ''),
                    };
                    _zMapMain.mapLandmark.refreshMarkerLandmark(marker_type, marker_id, data);
                }
            }, null, '-form', true);
        });

        /**
         * 情報表示エリア表示ボタン押下時イベントの処理を行います。
         */
        _zMapMain.on("mapLandmark:onclickRightareaShowButton",function(e)
        {
            /** 情報表示エリアを表示 */
            showRightAreaContainer();
            resizeDisplay();

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 情報表示エリア非表示ボタン押下時イベントの処理を行います。
         */
        _zMapMain.on("mapLandmark:onclickRightareaHideButton",function(e)
        {
            /** 情報表示エリアを隠す */
            hideRightAreaContainer();
            resizeDisplay();

            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        });

        /**
         * 地図マーカーの座標更新時のイベント処理を行います。
         */
        _zMapMain.on("mapLandmark:updateMarkerLatlon",function(e, marker_type, marker_id, params)
        {
            console.info(params);
            let type = $("input[name='search_types[]']:checked").val();
            let rowId       = marker_id || '';
            /** 取得した緯度・経度、および住所情報（住所、郵便番号、エリア）を最新化 */
            let latitude = params.latitude || '';
            let longitude = params.longitude || '';
            let zipcode = params.zipcode || '';
            let prefecture = params.prefecture || '';
            let municipality = params.municipality || '';
            let address_parts = params.address_parts || '';
            let address = params.address || '';
            // let area        = params.area || '';

            /** リストの対象項目の値を更新 */
            tr = $('#info_list' + type + '_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                tr.attr('data-prefecture', prefecture);
                tr.attr('data-municipality', municipality);
                tr.attr('data-address_parts', address_parts);
                tr.attr('data-address', address);
                tr.attr('data-zipcode', zipcode);
                tr.attr('data-latitude', latitude);
                tr.attr('data-longitude', longitude);
                // 表示内容更新
                tr.find('td.display-address p').eq(0).text(zipcode);
                tr.find('td.display-address p').eq(1).text(address);

                tr.find('#latitude').text(latitude);        // 緯度
                tr.find('#longitude').text(longitude);      // 経度
                tr.find('#zipcode').text(zipcode);          // 郵便番号
                tr.find('#address').text(address);          // 住所
            }
        });

        /**
         * 地図マーカーの吹き出し表示を開いた時のイベント処理を行います。
         */
        _zMapMain.on("markerLandmark:openedInfoBox",function(e, marker_type, marker_id)
        {
            let type = $("input[name='search_types[]']:checked").val();
            let rowId       = marker_id || '';
            tr = $('#info_list' + type + '_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                /** 対象行の背景色を選択色に変更 */
                tr.addClass('info_list-tr-selected');        // 当該行に選択色セット
            }

        });

        /**
         * 地図マーカーの吹き出し表示を閉じた時のイベント処理を行います。
         */
        _zMapMain.on("markerLandmark:closedInfoBox",function(e, marker_type, marker_id)
        {
            let type = $("input[name='search_types[]']:checked").val();
            let rowId       = marker_id || '';
            tr = $('#info_list' + type + '_table tr[data-row_id="' + rowId + '"]');
            if (tr) {
                /** 対象行の背景色を選択色をリセット */
                tr.removeClass('info_list-tr-selected');                          // 当該行の選択色リセット
            }

        });

        /** 内部変数初期化 */
        _address_search_data_ = false;

        /** 地図初期化 */
        initializeMap();

        /** 情報表示エリア表示化 */
        showRightAreaContainer();

        /** 情報リスト初期化処理 */
        initializeInfoList();

        /** 検索条件欄初期化処理 */
        $("input[name='search_types[]']").val(['1']);
        $('#search_input1, #search_input2, #search_input3').val(['']);

        /** 画面リサイズ処理 */
        resizeDisplay();
    }

    /**
     * 画面リサイズ処理を行います。
     */
    function resizeDisplay()
    {
        let windowHeight  = $(window).height();
        let headerHeight  = $('.main-header').first().height();
        let titleHeight   = 0;      //$('.content-header').first().height();
        let menuHeight    = $('.movement-menu').height();
        let footerHeight  = 0;      //$('.main-footer').first().height();
        let paddingHeight = 42;     //58;
        let totalHeight   = windowHeight - (headerHeight + titleHeight + menuHeight + footerHeight) - paddingHeight;

        $('#main_container').height(totalHeight);
        $('#left_area').height(totalHeight);
        $('#right_area').height(totalHeight);
    }

    /**
     * 情報表示エリアを表示します。
     */
    function showRightAreaContainer()
    {
        /** ボタンの表示・非表示切替え */
        _zMapMain.mapLandmark.showRightareaButton(2);

        /** リサイズバーを表示(左右エリア間) */
        $('#left_area').resizable({
            handles: 'e',
            resize: function( event, ui ) {
                _zMapMain.mapLandmark.resizeMap();
            },
            stop: function( event, ui ) {
                _zMapMain.mapLandmark.resizeMap();
            },
        });

        /** 左側エリアを縮小 */
        $('#left_area').animate({width: "55%"}, 500, function(){
            _zMapMain.mapLandmark.resizeMap();
        });

        /** 右側エリアを拡大 */
        $('#right_area').show().animate({width: "45%"}, 500, function(){
        });
   }

    /**
     * 情報表示エリアを非表示にします。
     */
    function hideRightAreaContainer()
    {
        /** ボタンの表示・非表示切替え */
        _zMapMain.mapLandmark.showRightareaButton(1);

        /** リサイズバーをクリア(左右エリア間) */
        if( $('#left_area').hasClass('ui-resizable')){
            $('#left_area').resizable('destroy');
        }

        /** 右側エリアを縮小 */
        $('#right_area').animate({width: "0%"}, 500, function(){
            $('#right_area').hide();
        });

        /** 左側エリアを拡大 */
        $('#left_area').animate({width: "100%"}, 500, function(){
            _zMapMain.mapLandmark.resizeMap();
        });
    }

    /**
     * 地図を初期化します。
     */
    function initializeMap()
    {
        _zMapMain.mapLandmark.init(_address_search_settings_);
    }

    /**
     * 地図表示をリセットします。
     * @param {*} isResetHome
     */
    function resetMap(isResetHome)
    {
        _zMapMain.mapLandmark.resetMap(isResetHome);
    }

    /**
     * 検索結果リストを初期化します。
     */
    function initializeInfoList()
    {
        clearInfoList('1');
        clearInfoList('2');
        clearInfoList('3');
    }

    /**
    * 住所検索データを取得します。
    */
    function getAddressSearchData(search_type, search_input)
    {
        if ((search_input || '').trim() === '') {
            return;
        }

        resetMap(true);
        initializeInfoList();

        switch(search_type.toString())
        {
            case '1':
                /** 住所検索 */
                searchInfoListAddress(search_input);
                break;

            case '2':
                /** 郵便番号検索 */
                searchInfoListZipcode(search_input);
                break;

            case '3':
                /** 施設名検索(POI検索) */
                searchInfoListFacility(search_input);
                break;
        }
    }

    /**
     * 住所検索を実行します。
     * ※webAPIの認証はLOCAL開発環境ではIP認証が通らないので、一度サーバーを経由する
     * @param {*} search_input
     */
    function searchInfoListAddress(search_input)
    {
        // init
        var list = [];
        // OAuthパラメタ取得
        let apiName = 'address/word';
        let data = {
            api: apiName,
            word: search_input,
            limit: [0,1000],
        };
        _ajax.post(_zMapMain.data('map_api_url'), data, function (result) {
            // WebAPI
            ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                if (status.code === 200 && res.info.hit > 0) {
                    let level = checkAddressLevel(res.item);
                    if (level) {
                        /** 取得データの住所階層レベルに従い、階層を絞って再検索 */
                        data.addrlevel = level;
                        ZDC.Search.getByZmaps(apiName, data, function(status, res) {
                            if (status.code === 200 && res.info.hit > 0) {
                                setList(res.item);
                            }
                        });
                    } else {
                        setList(res.item);
                    }
                }
            });
            function setList(response) {
                $(response).each(function(i, rec) {
                    list.push({
                        id: (i + 1),
                        search_type: 1,
                        facility_name: '',
                        zipcode: rec.zipcode,
                        prefecture: rec.parts[0],
                        municipality: rec.parts[1],
                        address_parts: rec.text.replace((rec.parts[0] + rec.parts[1]), ''),
                        address: rec.text,
                        code: rec.code,
                        level: rec.level,
                        point: rec.point,
                        latitude: rec.point.lat,
                        longitude: rec.point.lon,
                    });
                });
                // 地図セット
                _zMapMain.mapLandmark.setMapData({ 'landmarks': list });

                /** 並べ替えデータ取得 */
                list = getSortData(list, 'address', 1);

                /** リスト作成 */
                createInfoList(list, '1');

                /** 並べ替えアイコンを設定 */
                setSortIconInfoList('address', 1, '1');

                _address_search_data_ = list;
            }
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /**
    * 郵便番号検索を実行します。
    * @param {*} search_input
    */
    function searchInfoListZipcode(search_input)
    {
        let list = [];
        // OAuthパラメタ取得
        let apiName = 'address/zipcodelist';
        let data = {
            api: apiName,
            zipcode: search_input,
            limit: [0,1000],
        };
        _ajax.post(_zMapMain.data('map_api_url'), data, function (result) {
            ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                if (status.code === 200 && res.info.hit > 0) {
                    let level = checkAddressLevel(res.item);
                    $(res.item).each(function(i, rec) {
                        if (!level || level.indexOf(rec.address['level']) >= 0) {
                            /** データ編集 */
                            let parts = rec.address.parts.splice(2)
                            list.push({
                                id: (i + 1),
                                search_type: 2,
                                facility_name: '',
                                zipcode: rec.address.zipcode,
                                prefecture: rec.address.parts[0],
                                municipality: rec.address.parts[1],
                                address_parts: rec.address.text.replace((rec.address.parts[0] + rec.address.parts[1]), ''),
                                address: rec.address.text,
                                code: rec.address.code,
                                level: rec.address.level,
                                point: rec.address.point,
                                latitude: rec.address.point.lat,
                                longitude: rec.address.point.lon,
                            });
                        }
                    });
                    // 地図セット
                    _zMapMain.mapLandmark.setMapData({ 'landmarks': list });

                    /** 並べ替えデータ取得 */
                    list = getSortData(list, 'address', 1);

                    /** リスト作成 */
                    createInfoList(list, '2');

                    /** 並べ替えアイコンを設定 */
                    setSortIconInfoList('address', 1, '2');

                    _address_search_data_ = list;
                }
            });

        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /**
    * 施設名検索を実行します。
    * @param {*} search_input
    */
    function searchInfoListFacility(search_input)
    {
        let list = [];
        // OAuthパラメタ取得
        let apiName = 'poi/word';
        let data = {
            api: apiName,
            word: search_input,
            limit: [0,1000],
        };
        _ajax.post(_zMapMain.data('map_api_url'), data, function (result) {
            ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                if (status.code === 200 && res.info.hit > 0) {
                    /** 取得成功 */
                    $(res.item).each(function(i, rec) {
                        /** データ編集 */
                        list.push({
                            id: (i + 1),
                            search_type: 3,
                            facility_name: rec.text,
                            zipcode: rec.zipcode,
                            address: rec.addressText,
                            code: rec.code,
                            level: '',
                            point: rec.point,
                            latitude: rec.point.lat,
                            longitude: rec.point.lon,
                        });
                    });
                    // 地図セット
                    _zMapMain.mapLandmark.setMapData({ 'landmarks': list });

                    /** 並べ替えデータ取得 */
                    list = getSortData(list, 'facility_name', 1);

                    /** リスト作成 */
                    createInfoList(list, '3');

                    /** 並べ替えアイコンを設定 */
                    setSortIconInfoList('facility_name', 1, '3');

                    _address_search_data_ = list;
                }
            });
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    }

    /**
     * 住所階層判定
     * @param {*} data
     */
    function checkAddressLevel(data)
    {
        let level = false;

        /** 各階層の件数を取得 */
        let level_count =
        {
            'tod': 0,   // 都道府県
            'shk': 0,   // 市区町村
            'oaz': 0,   // 大字
            'azc': 0,   // 字丁目
            'gik': 0,   // 街区
            'tbn': 0,   // 地番
            'ebn': 0,   // 枝番
        };
        $(data).each(function(i, item){
            if (level_count.hasOwnProperty(item.level)) {
                level_count[item.level] ++;
            }
        });

        /** 各階層の件数をもとに階層レベルを取得 */
        if (level_count['tod'] > 1) {
            level = ['tod'];
        } else if (level_count['shk'] > 1) {
            level = ['shk'];
        } else if (level_count['oaz'] > 0 && level_count['oaz'] > 1) {
            level = ['oaz'];
        } else if (level_count['azc'] > 0 && level_count['azc'] > 1) {
            level = ['azc'];
        } else if (level_count['gik'] > 0 && level_count['gik'] > 1) {
            level = ['gik'];
        } else if (level_count['tbn'] > 0 || level_count['ebn'] > 0) {
            level = ['tbn', 'ebn'];
        }

        return level;
    }

    /**
     * 検索結果リストを生成します。
     * @param {*} list
     * @param {*} search_type
     */
    function createInfoList(list, search_type = '1')
    {
        // setting
        let messages = _address_search_settings_.messages;
        let listBlock = $('#info_list' + search_type);
        let tableId = 'info_list' + search_type + '_table';
        /** default(住所検索) */
        let listSettings = messages.info_list1;
        if (search_type.toString() === '2') {
            // 郵便番号検索
            listSettings = messages.info_list2;
        } else if (search_type.toString() === '3') {
            // 施設名検索
            listSettings = messages.info_list3;
        }
        // init
        listBlock.empty();
        let table  = $('<table id="' + tableId + '" class="table table-bordered table-hover dataTable info_list-table" data-type="' + search_type +'" role="list"></table>');

        /** ヘッダ部 **/
        let thead = $('<thead></thead>');
        let tbody = $('<tbody></tbody>');
        let tr = $('<tr role="row"></tr>');

        // tr生成
        $.each(listSettings, function(key, value) {
            let sorting = (value.hasOwnProperty('sorting') && value.sorting === true) ? 'sorting' : 'sorting_disabled';
            tr.append($('<th id="th_' + key + '" class="' + sorting + '" data-sort_key="' + key + '">' + value.label + '</th>'))
        });
        thead.append(tr);
        table.append(thead);

        /** ボディ部 **/
        $(list).each(function(i, item) {
            let _rowId = item.id;
            let _display = {};
            // tr生成
            tr = $('<tr role="row" data-type="' + search_type + '" data-row_id="' + _rowId + '"></tr>');
            // リスト表示設定以外の内部パラメタ項目data属性追加
            tr.attr('data-prefecture', (item.prefecture || ''));
            tr.attr('data-municipality', (item.municipality || ''));
            tr.attr('data-address_parts', (item.address_parts || ''));
            tr.attr('data-address', (item.address || ''));
            tr.attr('data-zipcode', (item.zipcode || ''));
            tr.attr('data-code', (item.code || ''));
            tr.attr('data-level', (item.level || ''));
            tr.attr('data-latitude', (item.latitude || ''));
            tr.attr('data-longitude', (item.longitude || ''));
            tr.attr('data-facility_name', (item.facility_name || ''));

            // 表示データ
            if (search_type.toString() === '1') {
                // 住所検索
                _display['address'] = '<p class="m-0">' + toZipcodeFormat(item.zipcode || '') + '</p><p class="m-0">' + item.address + '</p>';
                tr.attr('data-search_input', (item.address || ''));
            } else if (search_type.toString() === '2') {
                // 郵便番号検索
                _display['address'] = '<p class="m-0">' + toZipcodeFormat(item.zipcode || '') + '</p><p class="m-0">' + item.address + '</p>';
                tr.attr('data-search_input', (item.zipcode || ''));
            } else if (search_type.toString() === '3') {
                // 施設名検索
                _display['facility_name'] = item.facility_name;
                _display['address'] = '<p class="m-0">' + toZipcodeFormat(item.zipcode || '') + '</p><p class="m-0">' + item.address + '</p>';
                tr.attr('data-search_input', (item.facility_name || ''));
            }

            // td生成
            $.each(listSettings, function(key, value) {
                if (key === 'add') { // 地点登録
                    tr.append($('<td style="padding: 0;" class="text-center">' + '<a  href="javascript:void(0)" data-setting-modal="loading_point-setting-modal" data-action="' + url_setting_loading_point + '" class="info_list-table-td-btn-mark" role="button"><i class="fa fa-edit"></i><span class="button_text"></span></a>' + '</td>'));
                } else {
                    tr.append($('<td class="display-' + key + ' ' + (value.td_class || '') + '">' + _display[key] + '</td>'));
                }
            });
            tbody.append(tr);
        });
        table.append(tbody);
        listBlock.append(table);
    }

    /**
     * 検索結果リスト(施設名)をクリアします。
     */
    function clearInfoList(search_type)
    {
        /** ヘッダを残して一覧をクリア(空データで一覧を再作成) */
        createInfoList(null, search_type);

        /** 並べ替えアイコンを設定 */
        let column = search_type !== '3' ? 'address' :'facility_name';
        setSortIconInfoList(column, 1, search_type);

        _address_search_data_ = false;
    }

    /**
     * 検索結果リストの列ヘッダ押下時のイベント処理を行います。
     * @param {*} search_type
     * @param {*} column_id
     */
    function onClickThInfoList(search_type, column_id)
    {
        let tr = $('#info_list' + search_type + '_table thead tr');
        if (tr) {
            let sort_column = column_id.replace('#th_', '');
            let sort_type = (tr.find(column_id).hasClass('sorting') || tr.find(column_id).hasClass('sorting_desc') ? 1 : 2);

            /** 並べ替えデータ取得 */
            _address_search_data_ = getSortData(_address_search_data_, sort_column, sort_type);

            /** 並べ替えデータでリストを再作成 */
            createInfoList(_address_search_data_, search_type);
            _zMapMain.mapLandmark.closeInfoboxLandmarkAll();

            /** 並べ替えアイコンを設定 */
            setSortIconInfoList(sort_column, sort_type, search_type);
        }
        return false;
    }

    /**
     * 検索結果リストの並べ替えアイコンを設定します。
     * @param {*} sort_column
     * @param {*} sort_type
     * @param {*} search_type
     */
    function setSortIconInfoList(sort_column, sort_type, search_type)
    {
        // setting
        let messages = _address_search_settings_.messages;
        /** default(住所検索) */
        let listSettings = messages.info_list1;
        if (search_type.toString() === '2') {
            // 郵便番号検索
            listSettings = messages.info_list2;
        } else if (search_type.toString() === '3') {
            // 施設名検索
            listSettings = messages.info_list3;
        }
        let tr = $('#info_list' + search_type + '_table thead tr');
        if (tr) {
            // init
            tr.find('th').not('.sorting_disabled').removeClass('sorting_asc').removeClass('sorting_desc').addClass('sorting');
            // set
            $.each(listSettings, function(key, value) {
                if (value.hasOwnProperty('sorting') && value.sorting === true && key === sort_column) {
                    tr.find('#th_' + key).removeClass('sorting').addClass((sort_type === 1 ? 'sorting_asc' : 'sorting_desc'));
                    return false;
                }
            });
        }
        return false;
    }

    /**
     * 検索結果リストの並べ替えデータを取得します。
     * カラムがほぼ同じためデータソートは共通
     * @param {*} list
     * @param {*} sort_column
     * @param {*} sort_type
     */
    function getSortData(list, sort_column, sort_type)
    {
        let data    = $.extend(true, {}, list);
        data = Object.keys(data).map(key => data[key]);

        sort_column = ((sort_column || '').toString() === 'address' || (sort_column || '').toString() === 'facility_name') ? sort_column : 'address';
        sort_type   = ((sort_type || '').toString() === '1' || (sort_type || '').toString() === '2') ? sort_type : 1;

        switch(sort_column){

            case 'facility_name':       // 1.施設名列
                if ((sort_type || '').toString() === '1') {
                    /** 1:昇順 */
                    data.sort(function(item1,item2) {
                        /** 施設名 */
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) > 0) return 1;
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return 1;
                        /** ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2) {
                        /** 施設名 */
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) < 0) return 1;
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return 1;
                        /** ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;

            case 'address':             // 2.住所列
                if ((sort_type || '').toString() === '1') {
                    /** 1:昇順 */
                    data.sort(function(item1,item2){
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return 1;
                        /** 施設名 */
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) < 0) return -1;
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) > 0) return 1;
                        /** ID */
                        if((item1.id || '').toString() < (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() > (item2.id || '').toString()) return 1;
                        return 0;
                    });
                } else {
                    /** 2:降順 */
                    data.sort(function(item1,item2){
                        /** 郵便番号 */
                        if(toZipcodeFormat(item1.zipcode || '') > toZipcodeFormat(item2.zipcode || '')) return -1;
                        if(toZipcodeFormat(item1.zipcode || '') < toZipcodeFormat(item2.zipcode || '')) return 1;
                        /** 住所 */
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) > 0) return -1;
                        if (naturalStringCompare((item1.address || ''), (item2.address || '')) < 0) return 1;
                        /** 施設名 */
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) > 0) return -1;
                        if (naturalStringCompare((item1.facility_name || ''), (item2.facility_name || '')) < 0) return 1;
                        /** ID */
                        if((item1.id || '').toString() > (item2.id || '').toString()) return -1;
                        if((item1.id || '').toString() < (item2.id || '').toString()) return 1;
                        return 0;
                    });
                }
                break;
        }
        return data;
    }

 }
